const setMeta = (name, content, prop = false) => {
  const attr = prop ? 'property' : 'name';
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const setCanonical = (url) => {
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', url);
};

export const applyPageSEO = ({ title, description, keywords, url, ogTitle, ogDescription }) => {
  document.title = title;
  setMeta('description', description);
  setMeta('keywords', keywords);
  setMeta('og:title', ogTitle || title, true);
  setMeta('og:description', ogDescription || description, true);
  setMeta('og:url', url, true);
  setMeta('twitter:title', ogTitle || title);
  setMeta('twitter:description', ogDescription || description);
  setCanonical(url);
};